import React from "react";
import styled from "@emotion/styled";
import SellIcon from '@mui/icons-material/Sell';
import ErrorIcon from '@mui/icons-material/Error';
import { useTheme } from "@mui/styles";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import EditNoteIcon from '@mui/icons-material/EditNote';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SummarizeIcon from '@mui/icons-material/Summarize';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { useDispatch, useSelector } from "react-redux";
import { selectMortgageActionsNavSelection, setMortgageActionNavMenuSelection } from "../../../slices/sessionDataSlice";
import { Button, NavIndex, NavText, NavigationContainer, SideBarNavHeader, Typography } from "../../../StyledComponents";

const MortgageActionsNav = ({ mortgageData, reportsNumber, leadData, activeLead }) => {
  const theme = useTheme()
  const dispatch = useDispatch()

  const navSelection = useSelector(selectMortgageActionsNavSelection)
  
  const changeSelection = (content) => {
    dispatch( setMortgageActionNavMenuSelection(content))
  }

  return (
    <ModalNavRail className="modal">
      <ModalNavHeader className="modal">Actions</ModalNavHeader>
      <NavList>
      {navSelection ?
        <>
          {navSelection === 'reports' ?
            <ListItemNav selected top>
              <NavIndex className="nav-index">
                <SummarizeIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">View Reports ({reportsNumber})</NavText>
            </ListItemNav>
          : reportsNumber > 0 ?
            <ListItemNav onClick={() => changeSelection('reports')} top>
              <NavIndex className="nav-index">
                <SummarizeIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">View Reports ({reportsNumber})</NavText>
            </ListItemNav>
          :
            <ListItemNav top disabled>
              <NavIndex className="nav-index">
                <SummarizeIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">View Reports ({reportsNumber})</NavText>
            </ListItemNav>
          }
          {navSelection === 'notes' ?
            <ListItemNav selected>
              <NavIndex className="nav-index">
                <EditNoteIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">View/Add Notes ({mortgageData.mortgageNotes.length})</NavText>
            </ListItemNav>
          :
            <ListItemNav onClick={() => changeSelection('notes')}>
              <NavIndex className="nav-index">
                <EditNoteIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">View/Add Notes ({mortgageData.mortgageNotes.length})</NavText>
            </ListItemNav>
          }
          {navSelection === 'compareRecords' ?
            <ListItemNav selected>
              <NavIndex className="nav-index">
                <FileCopyIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">Compare Records</NavText>
            </ListItemNav>
          :
            <ListItemNav onClick={() => changeSelection('compareRecords')}>
              <NavIndex className="nav-index">
                <FileCopyIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">Compare Records</NavText>
            </ListItemNav>
          }
          {navSelection === 'propertyDetails' ?
            <ListItemNav selected>
              <NavIndex className="nav-index">
                <HomeWorkIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">View Property Details</NavText>
            </ListItemNav>
          :
            <ListItemNav onClick={() => changeSelection('propertyDetails')}>
              <NavIndex className="nav-index">
                <HomeWorkIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">View Property Details</NavText>
            </ListItemNav>
          }
          {!mortgageData.financialsPresent ?
            navSelection === 'provideTerms' || navSelection === 'provideFinancialsModal' ?
              <ListItemNav attention selected style={{padding: '0.1rem 0 0 0.3rem'}}>
                <NavIndex className="nav-index">
                  <AttachMoneyIcon fontSize="large" style={{color: `${theme.accent.caution.primary}`}} />
                </NavIndex>
                <NavText className="main">Provide Original Terms</NavText>
                <ErrorIcon style={{margin: '0 0 2.4rem 0.8rem', width: '1.2rem', color: `${theme.accent.caution.primary}`}} />
                <NavText className="label" style={{margin: '0 0 2.4rem 0', color: `${theme.accent.caution.primary}`}}>ToDo</NavText>
              </ListItemNav>
            :
              <ListItemNav attention onClick={() => changeSelection('provideTerms')} style={{padding: '0.1rem 0 0 0.3rem'}}>
                <NavIndex className="nav-index">
                  <AttachMoneyIcon fontSize="large" style={{color: `${theme.accent.caution.primary}`}} />
                </NavIndex>
                <NavText className="main">Provide Original Terms</NavText>
                <ErrorIcon style={{margin: '0 0 2.4rem 0.8rem', width: '1.2rem', color: `${theme.accent.caution.primary}`}} />
                <NavText className="label" style={{margin: '0 0 2.4rem 0', color: `${theme.accent.caution.primary}`}}>ToDo</NavText>
              </ListItemNav>
          :
            <></>
          }
          {navSelection === 'editTags' ?
            <ListItemNav selected>
              <NavIndex className="nav-index">
                <SellIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">View/Add Tags</NavText>
            </ListItemNav>
          :
            <ListItemNav onClick={() => changeSelection('editTags')}>
              <NavIndex className="nav-index">
                <SellIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">View/Add Tags</NavText>
            </ListItemNav>
          }
          {activeLead && navSelection === 'addAssignees' ?
            <ListItemNav selected>
              <NavIndex className="nav-index">
                <PersonAddIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">Manage Assignees {leadData && leadData.assigneeIds && leadData.assigneeIds.length > 0 && mortgageData.assigneeIds.length > 0 ? `(${leadData.assigneeIds.length + mortgageData.assigneeIds.length})` : mortgageData.assigneeIds.length > 0 ? `(${mortgageData.assigneeIds.length})` : leadData.assigneeIds && leadData.assigneeIds.length > 0 ? `(${leadData.assigneeIds.length})` : ''}</NavText>
            </ListItemNav>
          : activeLead ?
            <ListItemNav onClick={() => changeSelection('addAssignees')}>
              <NavIndex className="nav-index">
                <PersonAddIcon fontSize="large" />
              </NavIndex>
              <NavText className="main">Manage Assignees {leadData && leadData.assigneeIds && leadData.assigneeIds.length > 0 && mortgageData.assigneeIds.length > 0 ? `(${leadData.assigneeIds.length + mortgageData.assigneeIds.length})` : mortgageData.assigneeIds.length > 0 ? `(${mortgageData.assigneeIds.length})` : leadData.assigneeIds && leadData.assigneeIds.length > 0 ? `(${leadData.assigneeIds.length})` : ''}</NavText>
            </ListItemNav>
          :
            <></>
          }
        </>
      :
        <>
          <ListItemNav disabled>
            <NavIndex className="nav-index">
              <SummarizeIcon fontSize="medium" />
            </NavIndex>
            <NavText className="disabled">View Reports</NavText>
          </ListItemNav>
          <ListItemNav disabled>
            <NavIndex className="nav-index">
              <EditNoteIcon fontSize="medium" />
            </NavIndex>
            <NavText className="disabled">View/Add Notes</NavText>
          </ListItemNav>
          <ListItemNav disabled>
            <NavIndex className="nav-index">
              <FileCopyIcon fontSize="medium" />
            </NavIndex>
            <NavText className="disabled">Compare Records</NavText>
          </ListItemNav>
          <ListItemNav disabled>
            <NavIndex className="nav-index">
              <HomeWorkIcon fontSize="medium" />
            </NavIndex>
            <NavText className="disabled">View Property Details</NavText>
          </ListItemNav>
          <ListItemNav disabled>
            <NavIndex className="nav-index">
              <SellIcon fontSize="medium" />
            </NavIndex>
            <NavText className="disabled">Mortgage Tags</NavText>
          </ListItemNav>
          <ListItemNav disabled>
            <NavIndex className="nav-index">
              <PersonAddIcon fontSize="medium" />
            </NavIndex>
            <NavText className="disabled">Manage Assignees</NavText>
          </ListItemNav>
        </>
      }
      </NavList>
      {navSelection &&
        <NavFooter>
            {mortgageData.status === 'inactive' ?
              <FooterButton 
                className={navSelection === 'investigateLead' ? "primaryActive disabled" : "primary" }
                disabled={navSelection === 'investigateLead'}
                onClick={navSelection === 'investigateLead' ? null : () => changeSelection('investigateLead')}
              >
                <Typography className="small">Open Investigation</Typography>
              </FooterButton>
            : mortgageData.status === 'awaitingUpdate' ?
              <FooterButton 
                className={navSelection === 'confirmUpdate' ? "primaryActive disabled" : "primary" }
                disabled={navSelection === 'confirmUpdate'}
                onClick={navSelection === 'confirmUpdate' ? null : () => changeSelection('confirmUpdate')}
              >
                <Typography className="small">Confirm Updates</Typography>
              </FooterButton>
            : <></>}
        </NavFooter>
      }
    </ModalNavRail>
  )
}

const ModalNavRail = styled(NavigationContainer)(({ theme }) => `
  &.modal {
    grid-column: 1;
    grid-row: 2;
    min-height: 0;
    max-height: 100%;
    background: ${theme.palette.common.cardBackground};
    border: 0.1rem solid ${theme.palette.common.grayBorder};
    border-radius: 0.8rem;
    box-shadow: none;
    overflow: hidden;
  }
`)

const ModalNavHeader = styled(SideBarNavHeader)(({ theme }) => `
  &.modal {
    flex: 0 0 auto;
    margin: 0;
    padding: 1.2rem 1rem 0.7rem 1rem;
    color: ${theme.palette.common.black};
    font-size: 1.05rem;
    font-weight: 750;
    border-right: none;
    border-bottom: 0.1rem solid ${theme.palette.common.grayBorder};
    background: ${theme.palette.common.grayBorderLight};
  }
`)

const NavList = styled.div(({ theme }) => `
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 0.38rem;
    background-color: ${theme.palette.common.grayBorderLight};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 999rem;
    border: 0.1rem solid ${theme.palette.common.grayBorder};
    background-color: ${theme.palette.common.grayText};
  }
`)

const NavFooter = styled.div(({ theme }) => `
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 0.6rem;
  margin-top: auto;
  padding: 1rem;
  border-top: 0.1rem solid ${theme.palette.common.grayBorder};
  background: ${theme.palette.common.white};
`)

const FooterButton = styled(Button)(({ theme }) => `
  && {
    width: 100%;
    min-height: 3.2rem;
    margin: 0;
    padding: 0.78rem 1rem;
    border-radius: 0.9rem;
    font-size: 0.98rem;
    font-weight: 760;
    line-height: 1.15;
    box-shadow: 0 0.45rem 1rem rgba(15, 23, 42, 0.08);

    .small {
      width: 100%;
      color: inherit;
      font-size: 0.98rem;
      font-weight: 760;
      line-height: 1.15;
      text-align: center;
      letter-spacing: 0;
    }

    &.primary {
      color: ${theme.palette.common.white};
      border-color: rgba(14, 132, 75, 0.84);
      background: linear-gradient(180deg, #22B24A 0%, #169B35 100%);
      box-shadow: 0 0.55rem 1.25rem rgba(22, 163, 74, 0.22), inset 0 0.1rem 0 rgba(255, 255, 255, 0.22);
    }

    &.primaryActive {
      color: #7C8A93;
      border-color: #D6DDE5;
      background: linear-gradient(180deg, #F6F8FA 0%, #EDF1F5 100%);
      box-shadow: inset 0 0.1rem 0 rgba(255, 255, 255, 0.9);
      cursor: not-allowed;
    }
  }
`)

const ListItemNav = styled.a`
  display: flex;
  align-items: center;
  gap: 0.1rem;
  min-height: 3.75rem;
  font-weight: 700;
  border-radius: 0;
  padding: 0.45rem 0.75rem;
  margin: 0;
  background-color: ${(props) => props.attention && props.selected ? 'rgba(245,158,11,0.16)' : props.attention ? `rgba(245,158,11,0.1)` : props.selected && !props.disabled ? "rgba(37,99,235,0.08)" : props.disabled ? "rgba(248,250,252,0.55)" : "transparent"};
  cursor: ${(props) => props.selected || props.noCursor ? "default" : props.disabled ? 'not-allowed' : "pointer"};
  color: ${(props) => props.disabled ? '#939599' : props.selected ? '#1e40af' : '#334155'};
  border-top: ${(props) => props.top ? "none" : "none"};
  border-bottom: 0.1rem solid rgba(203, 213, 225, 0.72);
  border-left: ${(props) => props.selected && !props.disabled ? "0.25rem solid #2563eb" : props.attention ? "0.25rem solid #d97706" : "0.25rem solid transparent"};

  .nav-index {
    flex: 0 0 2.4rem;
    width: 2.4rem;
    margin: 0;
    color: inherit;

    svg {
      width: 1.45rem;
      height: 1.45rem;
    }
  }

  .main,
  .disabled {
    min-width: 0;
    color: inherit;
    font-size: 0.92rem;
    font-weight: 760;
    line-height: 1.15;
    letter-spacing: 0;
  }

  .label {
    font-size: 0.72rem;
    font-weight: 900;
    text-transform: uppercase;
  }

  &:hover {
    background-color: ${(props) => props.attention && props.selected ? 'rgba(245,158,11,0.2)' : props.attention ? 'rgba(245,158,11,0.14)' : props.selected && !props.disabled ? "rgba(37,99,235,0.1)" : props.disabled ? "rgba(248,250,252,0.55)" : "rgba(248,250,252,0.95)"};
  }
`

export default MortgageActionsNav;
